export * from './update-profile-page.component';
